import { Box, Button, FlatList, HStack, Pressable, Input, Modal, Text, VStack } from "native-base";
import { useEffect, useRef, useState } from "react";
import { Alert, Image, ImageBackground, Platform, Dimensions, ScrollView   } from "react-native";

import DateTimePicker from '@react-native-community/datetimepicker';


import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR'

import { carteira, compraCredito } from "../services/Credito";




import Clipboard from "@react-native-clipboard/clipboard";
import { getAuth, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../../firebaseConfig";
import { useNavigation } from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { LinearGradient } from "expo-linear-gradient";


import * as Notifications from "expo-notifications";
import {RootStackParamList} from "../types";
import {useTransacoes} from "../hooks/useTransacoes";

const windowWidth = Dimensions.get('window').width;

const windowHeight = Dimensions.get("window").height;



const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: true,
    shouldSetBadge: false,
  }),
});


type HomeScreenProps = {
    onSignOut: () => void;
};


function HomeScreen({ onSignOut }: HomeScreenProps) {
  const [balance, setBalance] = useState<any>(0);
  const [credito, setCredito] = useState<string>("");
  const [envioCredito, setEnvioCredito] = useState<boolean>(false);
  const [qrCode, setQrCode] = useState<string>("");
  const [linkVisualizacao, setLinkVisualizacao] = useState<string>("")
  const [transactions, setTransactions] = useState<
    Array<{ id: string; description: string; amount: number }>
  >([
    { id: "1", description: "CRÉDITO CONTA CLIENTE", amount: 1500 },
    { id: "2", description: "TRANSFERÊNCIA MOTORISTA CÓD 56748", amount: -200 },
    { id: "3", description: "TRANSFERÊNCIA MOTORISTA CÓD 57890", amount: -300 },
  ]);

    const [inputDate, setInputDate] = useState('');



    const [isNotified, setIsNotified] = useState(false);

  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [isModalOutOpen, setModalOutOpen] = useState<boolean>(false);



  const navigation = useNavigation()

    const fetchCarteira = async () => {
        try {
            const userUid = await AsyncStorage.getItem("user_id");
            if (!userUid) {
                Alert.alert("Erro", "Usuário não autenticado.");
                return;
            }

            const response = await carteira({ id_remoto: userUid });

            if (response?.data?.saldo) {
                const userBalance = response.data.saldo;
                setBalance(userBalance);

                if (userBalance <= 10 && !isNotified) {
                    sendNotification("Atenção", "Seu saldo está abaixo de R$ 10. Recarregue sua conta.");
                    setIsNotified(true);
                } else if (userBalance > 10) {
                    setIsNotified(false);
                }

            } else {
                throw new Error("Dados da carteira não encontrados.");
            }
        } catch (error) {
            console.error("Erro ao buscar dados da carteira:", error);
        }
    };



    const sendNotification = async (title: string, body: string) => {
    if (Platform.OS === "android" || Platform.OS === "ios") {
      await Notifications.scheduleNotificationAsync({
        content: {
          title,
          body,
          sound: true,
        },
        trigger: null, // Dispara imediatamente
      });
    } else {
      console.warn("Notificações não são suportadas no ambiente web.");
    }
  };


  useEffect(() => {
    fetchCarteira();
      const intervalId = setInterval(() => {
          fetchCarteira();
      }, 10000);
      console.log(intervalId)
    return () => clearInterval(intervalId)
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      await AsyncStorage.removeItem("user_id");
      navigation.navigate("Auth");
      setModalOutOpen(false)
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
      Alert.alert("Erro", "Ocorreu um erro ao sair. Tente novamente.");
    }
  };

  const handleSolicitarCredito = async () => {
    if (!credito) {
      Alert.alert("Erro", "Por favor, insira um valor válido.");
      return;
    }

    try {
      const userUid = await AsyncStorage.getItem("user_id");
      if (!userUid) {
        Alert.alert("Erro", "Usuário não autenticado.");
        return;
      }

      setEnvioCredito(true);
      const response = await compraCredito({
        id_remoto: userUid,
        perfil: 1,
        status: 0,
        tipo: 1,
        valor: credito
      });

      if (response.dadosCobranca.imagemQrcode) {
        setQrCode(response.dadosCobranca.imagemQrcode);
        setLinkVisualizacao(response.dadosCobranca.qrCode);
      //  Alert.alert("Sucesso", "Crédito solicitado com sucesso!");

      //  await fetchCarteira();
      } else {
        throw new Error("Resposta inválida");
      }

      setCredito("");
    } catch (error) {
      Alert.alert("Erro", "Ocorreu um erro ao solicitar o crédito.");
      console.error(error);
    } finally {
      setEnvioCredito(false);
    }
  };

  const prevBalanceRef = useRef<any>(balance);

  useEffect(() => {
  const saldoAumentou = balance > prevBalanceRef.current;

    if (saldoAumentou && isModalOpen) {
      setModalOpen(false);
      setQrCode("");
      refetch(); 
    }

    prevBalanceRef.current = balance;
  }, [balance]);



    const [userId, setUserId] = useState<string | null>(null);

    useEffect(() => {
        const loadUserId = async () => {
            const id = await AsyncStorage.getItem("user_id");
            if (id) setUserId(id);
        };
        loadUserId();
    }, []);

    const { data, isLoading, isError, refetch } = useTransacoes(userId ?? "");

    if (!userId) {
        return <Text>Aguardando usuário...</Text>;
    }

    if (isLoading) {
        return <Text>Carregando...</Text>;
    }

    if (isError || !data) {
        return <Text>Erro ao carregar transações.</Text>;
    }


    const filteredTransacoes = inputDate.length === 10
        ? data.transacoes.filter((item) => {
            const formattedItemDate = format(
                new Date(item.data_transacao),
                'dd/MM/yyyy'
            );
            return formattedItemDate === inputDate;
        })
        : data.transacoes;


    const formatDateInput = (text: string) => {
        const cleaned = text.replace(/\D/g, '');

        if (cleaned.length <= 2) return cleaned;
        if (cleaned.length <= 4) return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
        return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4, 8)}`;
    };

    const handleCreditoChange = (text: string) => {
        // Remove tudo que não for número
        const numeric = text.replace(/\D/g, '');

        // Se estiver vazio, define como vazio
        if (numeric.length === 0) {
            setCredito('');
            return;
        }

        // Converte para número com duas casas decimais e vírgula
        const valor = (parseInt(numeric, 10) / 100).toFixed(2).replace('.', ',');

        setCredito(valor);
    };


    return (
    <VStack flex={1} bg="white.100">
      {/* Header com ImageBackground */}
      <ImageBackground
          source={{ uri: 'https://taentregue.com.br/imagem/tela_home.png' }}
        style={{ width: "100%", height: 257 }}
        resizeMode="cover"
      >
          <Image
              source={{ uri: 'https://taentregue.com.br/imagem/logo.png' }}
              style={{
                  width: windowWidth,
                  height: windowWidth * 0.1,
                  resizeMode: 'contain',
                  marginTop: 12
              }}
          />
         <Box flex={1} alignItems="center" justifyContent="center" p={6}>
              <VStack alignItems="center" space={2}>

                <Text color="white" fontSize="md">
                meu saldo
                </Text>
                <Text color="white" fontSize="32px" bold>
                R$ {balance.toLocaleString()}
                </Text>
            </VStack>
            {/* Adicionar espaço entre saldo e botão
            <Box mt={4}>
               <Button
                variant="outline"
                borderRadius="full"
                borderWidth={1}
                borderColor="white"
                _text={{
                    color: "white",
                    fontWeight: "bold",
                }}
                onPress={() => navigation.navigate('DetalhesConta')}
                >
                detalhe da conta
                </Button>
            </Box>  */}
          </Box>
      </ImageBackground>

      {/* Icons Section */}
      <HStack justifyContent="space-around" mt={6} mb={4} px={4}>

       {/*  <VStack alignItems="center">
             <Pressable
                onPress={() => {
                  setModalOutOpen(true)
                } }
                bg="#BFE7F1"
                height="59px"
                width="66px"
                borderRadius="12px"
                shadow={2}
                alignItems="center"
                justifyContent="center"
              >
            <Image
              source={require("../assets/buscar_motoristas.png")}
              style={{ width: 30, height: 20 }}
            />
            </Pressable>
            <Text mt={2} fontSize="sm" color="gray.800">
            buscar motoristas
            </Text>
              </VStack> */ }
        <VStack alignItems="center">
            <Pressable
                onPress={() => {
                  navigation.navigate("MinhaConta");
                } }
                bg="#BFE7F1"
                height="59px"
                width="66px"
                borderRadius="12px"
                shadow={2}
                alignItems="center"
                justifyContent="center"
              >
              <Image   source={{ uri: 'https://taentregue.com.br/imagem/area_cliente.png' }} style={{ width: 20, height: 20 }} />
            </Pressable>
            <Text mt={2} fontSize="sm" color="gray.800">
            área do cliente
            </Text>
        </VStack>
        <VStack alignItems="center">
           <Pressable
                onPress={() => {
                  setModalOutOpen(true)
                } }
                bg="#BFE7F1"
                height="59px"
                width="66px"
                borderRadius="12px"
                shadow={2}
                alignItems="center"
                justifyContent="center"
              >
              <Image  source={{ uri: 'https://taentregue.com.br/imagem/configuracoes.png' }}  style={{ width: 20, height: 20 }} />
            </Pressable>
            <Text mt={2} fontSize="sm" color="gray.800">
            configurações
            </Text>
        </VStack>
       </HStack>


    {/* isModalOutOpen */}
    <Modal isOpen={isModalOutOpen} onClose={() => setModalOutOpen(false)} size="lg">
      <Modal.Content>
        <Modal.CloseButton />
        <Modal.Header>Configurações</Modal.Header>
        <Modal.Body>
            <VStack space={4}>
              {/* Sair */}
              <Button
                isLoading={envioCredito}
                onPress={handleSignOut}
                colorScheme="danger"
              >
               Sair
              </Button>
            </VStack>
        </Modal.Body>
      </Modal.Content>
    </Modal>

    {/* Modal */}
    <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)} size="lg" closeOnOverlayClick={false} >
      <Modal.Content>
        <Modal.CloseButton />
        <Modal.Header>Carteira</Modal.Header>
        <Modal.Body>
          {qrCode ? (
            <VStack alignItems="center" space={4}>
              <h3>{credito}</h3>
              {/* Exibição do QR Code */}
              <Image
                source={{ uri: qrCode }}
                style={{ width: 200, height: 200 }}
                alt="QR Code"
              />
              <Button
                onPress={() => Clipboard.setString(linkVisualizacao.replace('.', '[.]'))}
                colorScheme="blue"
              >
                Copiar Link
              </Button>
            </VStack>
          ) : (
            <VStack space={4}>
              {/* Input de valor */}
              <Text>Digite o valor do crédito:</Text>
              <Input
                  placeholder="Ex: 199,99"
                  keyboardType={Platform.OS === 'ios' ? 'decimal-pad' : 'numeric'}
                  value={credito}
                  onChangeText={handleCreditoChange}
              />
              <Button
                isLoading={envioCredito}
                onPress={handleSolicitarCredito}
                colorScheme="blue"
              >
                Solicitar Crédito
              </Button>
            </VStack>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onPress={async () => {
            setModalOpen(false)
            setQrCode("")
            await fetchCarteira();
            await refetch();
            }}>Fechar</Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>

      {/* Transaction History */}
        <Box
            maxHeight={windowHeight * 0.5}
            bg="white"
            roundedTop="2xl"
            shadow={2}
            pb={2}
        >
            <Text fontSize="lg" color="#384085" bold mt={4} mb={2} ml={4}>
                Movimento da Conta
            </Text>

            <Box px={4} mt={0}>
                <Text mb={1} fontSize="sm" color="gray.700">
                    Filtrar transações por data (formato dd/mm/aaaa)
                </Text>
                <Input
                    placeholder="dia/mes/ano"
                    value={inputDate}
                    onChangeText={(text) => {
                        const formatted = formatDateInput(text);
                        setInputDate(formatted);
                    }}
                    keyboardType="numeric"
                    variant="filled"
                    bg="#E5F9FF"
                    borderColor="#00A3C4"
                />
            </Box>

            <FlatList
                data={filteredTransacoes}
                keyExtractor={(item, index) => `${item.id}-${index}`}
                ListFooterComponent={<Box height={80} />}
                showsVerticalScrollIndicator={true}
                renderItem={({ item }) => {
                    const formattedDate = format(
                        new Date(item.data_transacao),
                        "dd/MM/yyyy 'às' HH:mm",
                        { locale: ptBR }
                    );

                    return (
                        <Box p={4}  borderBottomWidth={1} borderColor="gray.200">
                            <Text fontSize="sm">TRANSAÇÃO</Text>
                            <Text
                                fontSize="md"
                                bold
                                color={parseFloat(item.valor.replace(",", ".")) < 0 ? "red.500" : "green.500"}
                            >
                                R$ {item.valor}
                            </Text>
                            <Text fontSize="xs" color="gray.500">
                                {formattedDate}
                            </Text>
                        </Box>
                    );
                }}
            />

        </Box>


        <Box
            position="absolute"
            bottom={0}
            width="100%"
            bg="white"
            shadow={4}
            zIndex={10}
        >
            <LinearGradient
                colors={["#3595AF", "#27348B"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
            >
                <Button
                    onPress={() => setModalOpen(true)}
                    bg="transparent"
                    h="75px"
                    _text={{ color: "white", fontWeight: "700", fontSize: '18px' }}
                >
                    recarregar saldo
                </Button>
            </LinearGradient>
        </Box>
    </VStack>
  );
};

export default HomeScreen;
